import { render, staticRenderFns } from "./send-detail.vue?vue&type=template&id=85315eec"
import script from "./send-detail.vue?vue&type=script&lang=js"
export * from "./send-detail.vue?vue&type=script&lang=js"
import style0 from "./send-detail.vue?vue&type=style&index=0&id=85315eec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports